import styled from "styled-components";
import { Link as LinkS } from "react-scroll";

export const Wrapper = styled(LinkS)`
  position: fixed;
  width: 50px;
  height: 50px;
  bottom: 50px;
  right: 50px;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  background-color: ${({ theme }) => theme.color1}af;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  transform: rotate3d(0, 0, 1, -30deg);
  transition: visibility 1s, opacity 1s linear, transform 0.5s;
  z-index: 3;
  @media screen and (max-width: 576px) {
    right: 15px;
    bottom: 20px;
  }
  &:hover {
    transform: rotate3d(0, 0, 0, 0);
    cursor: pointer;
    background-color: ${({ theme }) => theme.color1};
    & > i {
      /* color: ${({ theme }) => theme.color1}; */
    }
  }
  i {
    color: ${({ theme }) => theme.color3};
    font-size: 5ch;
  }
`;
